export default __webpack_public_path__ + "static/media/winston-takecover.beeb7008.mp3";